class ProductCarousel extends HTMLElement {
  constructor() {
    super();

    window.loadSwiper.then(({ Swiper }) => {
      const swiperParams = {
        slidesPerView: "auto",
        cssMode: true,
        navigation: {
          nextEl: this.querySelector("[data-product-carousel-navigation-next]"),
          prevEl: this.querySelector("[data-product-carousel-navigation-previous]"),
        },
      };

      this.swiper = new Swiper(
        this,
        swiperParams,
      );
    });
  }

  connectedCallback() {

  }

  disconnectedCallback() {
  }
}

if (!customElements.get("product-carousel")) {
  customElements.define("product-carousel", ProductCarousel);
}
